function PMID() {
  return (
    <div>
      <li className="bullet-item">
        The publication(s) that reports the variant-disease association, with the{' '}
        <a className="tt" target="_blank" rel="noreferrer" href="http://www.ncbi.nlm.nih.gov/pubmed/">
          Pubmed Identifier
        </a>
      </li>
    </div>
  );
}

export default PMID;
